import $ from 'jquery'

function smartSearch($element) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $smartSearchInput,
      $smartSearchForm,
      $smartSuggestBox,
      $smartSearchBar,
      $smartSearchClose,
      requestTimeout;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $smartSearchInput        = $('.flexible-header__searchfield', $mainContainer);
    $smartSearchForm         = $('#flexible-header__search-form');
    $smartSuggestBox         = $('.flexible-header__searh-form__suggests');
    $smartSearchBar          = $('.flexible-header__row--search');
    $smartSearchClose        = $('.flexible-header__row--search .w-flexible-header__close');

    bindDomElements();
  }

  function bindDomElements() {
    // Submit
    $('.search-icon, .w-search-bar-icon', $mainContainer).on('click', submitSearch);

    // Keyups
    $smartSearchInput.on('keyup', keyUpHandler);
  }

  function keyUpHandler(e) {
    switch (e.keyCode) {
      case $.ui.keyCode.ENTER:
        submitSearch();
        break;
      case $.ui.keyCode.UP:
        break;
      case $.ui.keyCode.DOWN:
        break;
      case $.ui.keyCode.TAB:
        break;
      default:
        keyUpDefault();
        break;
    }
  }

  function keyUpDefault() {
    var val = $.trim($smartSearchInput.val());

    // send request only after 3 symbols
    if ( val != '' && val.length >= 3 ) {
      openSuggestBox();
      sendSuggestRequest( val );
    } else {
      closeSuggestBox();
    }
  }

  function closeSuggestBox() {
    $smartSuggestBox.hide();
    $smartSearchBar.removeClass('overflow-visible');
    // unbind events
    $smartSearchInput.off('keydown');
    $smartSuggestBox.off('keydown', 'a');
  }

  function openSuggestBox() {
    if ( $smartSuggestBox.is(':visible') ) return false;
    $smartSuggestBox.show();
    $smartSearchBar.addClass('overflow-visible');

    // Hide Suggest off event
    $('body').on('click', function(e) {
      var $target = $(e.target);

      if ( !$target.parents('.flexible-header__search-bar').length ) {
        closeSuggestBox();
      }
    });

    // ADA Compliance
    $smartSearchInput.on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.DOWN) {
        e.preventDefault();
        $(this).trigger('blur');
        setTimeout(function() {
          $('a:first-child', $smartSuggestBox).trigger('focus');
        }, 50);
      }

      if (e.keyCode == $.ui.keyCode.UP) {
        e.preventDefault();
        $(this).trigger('blur');
        setTimeout(function() {
          $('a:last-child', $smartSuggestBox).trigger('focus');
        }, 50);
      }

      if (e.keyCode == $.ui.keyCode.TAB) {
        e.preventDefault();
        closeSuggestBox();
        $smartSearchClose.trigger('focus');
      }

      if (e.keyCode == $.ui.keyCode.ESCAPE) {
        e.preventDefault();
        closeSuggestBox();
      }
    });

    $smartSuggestBox.on('keydown', 'a', function(e) {
      var $link = $(this);
      if (e.keyCode == $.ui.keyCode.DOWN) {
        e.preventDefault();
        $link.trigger('blur');

        setTimeout(function() {
          if ($link.is(':last-child')) {
            $smartSearchInput.trigger('focus');
          } else {
            if ( $link.next().is('a') ) { $link.next().trigger('focus'); }
            else { $link.next().next().trigger('focus'); }
          }
        }, 50);
      }

      if (e.keyCode == $.ui.keyCode.UP) {
        e.preventDefault();
        $link.trigger('blur');

        setTimeout(function() {
          if ($link.is(':first-child')) {
            $smartSearchInput.trigger('focus');
          } else {
            if ( $link.prev().is('a') ) { $link.prev().trigger('focus'); }
            else { $link.prev().prev().trigger('focus'); }
          }
        }, 50);
      }

      if (e.keyCode == $.ui.keyCode.TAB) {
        e.preventDefault();
        closeSuggestBox();
        $smartSearchClose.trigger('focus');
      }

      if (e.keyCode == $.ui.keyCode.ESCAPE) {
        e.preventDefault();
        closeSuggestBox();
      }
    });
  }

  function sendSuggestRequest(q) {
    // get URL param from config \ options
    var url = window.location.href.split("/")[0] + '//' + $smartSearchForm.data('searchAppHost') + "/autocomplete?q=" + encodeURIComponent(q) + "&callback=?";

    // add delay
    clearTimeout(requestTimeout);
    requestTimeout = setTimeout(function() {
      SOPHIA.ajax({
        dataType: 'json',
        url: url,
        success: function(data) {
          if (data.success) {
            updateSuggests(data);
          } else {
            SOPHIA.modalMessage('Sorry, a problem occured. Please, try again later.', 'error', $smartSearchInput)
          }
        }
      })
    }, 200);
  }

  function updateSuggests( data ) {
    var buckets = [];
    for (var k in data.buckets) {
      if ( data.buckets.hasOwnProperty(k) ) { buckets.push( data.buckets[k] ); } // eslint-disable-line
    }

    var suggestsObj = {
      value: $.trim($smartSearchInput.val()),
      croppedValue: $smartSearchInput.val(),
      suggestedValue: data.suggestions[0] || $smartSearchInput.val(),
      buckets: {
        tutorial: $.inArray('Packet', buckets) >= 0 ? true: false,
        spcc_course: $.inArray('SpccCourse', buckets) >= 0 ? true: false,
        program: $.inArray('Program', buckets) >= 0 ? true: false
      }
    }

    var suggestedValue = encodeURIComponent(suggestsObj.suggestedValue)

    suggestsObj.entireSiteUrl = SOPHIA.Routes.search_path() + '?q=' + suggestedValue

    for (var i in data.bucketsWithFound) {
      var item = data.bucketsWithFound[i]
      if ( item.bucket == "SpccCourse" ) {
        if (item.numFound == 1 ) {
          var slug = item.doclist.docs[0].slug_ss
          suggestsObj.courseUrl = SOPHIA.Routes.course_landing_page_spcc_course_path(slug)
        } else {
          suggestsObj.courseUrl = SOPHIA.Routes.spcc_courses_search_path() + '?q=' + suggestedValue
        }
      }
      if (item.bucket == "Program") {
        var domain = item.doclist.docs[0].domain_ss
        suggestsObj.programUrl = "https://" + domain
      }
      if (item.bucket == "Packet") {
        suggestsObj.tutorialUrl = SOPHIA.Routes.packets_search_path() + '?q=' + suggestedValue
      }
    }

    /* suggestion word without sought-for letters */

    var restObj = {
      restValue: suggestsObj.suggestedValue.replace(new RegExp(suggestsObj.croppedValue, "ig"), '')
    }

    $.extend( suggestsObj, restObj );

    suggestsObj.suggestions = [];
    for (var j in data.suggestions) {
      if ( data.suggestions.hasOwnProperty(j) ) { // eslint-disable-line
        var tempSuggest = {};
        tempSuggest.allBodyUrl = SOPHIA.Routes.search_path() + '?q=' + data.suggestions[j];
        tempSuggest.body = data.suggestions[j].replace(new RegExp(suggestsObj.croppedValue, "ig"), ''); /* the rest part of suggestions without sought-for letters */
        tempSuggest.strongVal = suggestsObj.croppedValue; /* sought-for letters */
        suggestsObj.suggestions.push(tempSuggest);
      }
    }

    $smartSuggestBox.html( SOPHIA.searchTemplate(suggestsObj) );
  }

  function submitSearch() {
    $smartSearchForm.trigger('submit');
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
}

// jQuery plugin method
$.fn.smartSearch = function() {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('smartSearch')) {
      $this.data('smartSearch', smartSearch($this));
    }
  });
};
